module.exports = __webpack_public_path__ + "img/layers-fill.251bd5e1.svg";